module.exports = __webpack_public_path__ + "img/pompe-a-carburant.307f650f.png";